class WishlistModal extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.productsInLists = 0
  }

  connectedCallback () {
    super.connectedCallback()

    this.activator = null
    this.locked = false
    this.checkIfProductInList()
  }

  setupListeners () {
    super.setupListeners()

    this.onCloseClick = this.onCloseClick.bind(this)
    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onCreateFormSubmit = this.onCreateFormSubmit.bind(this)
    this.onCreateTriggerClick = this.onCreateTriggerClick.bind(this)

    this.listeners.add(document.body, 'click', this.onTriggerClick)
    this.listeners.add(this, 'click', this.onCloseClick)
    this.listeners.add(
      this.els['create-form'].element,
      'submit',
      this.onCreateFormSubmit,
    )
    this.listeners.add(
      this.els['create-trigger'].element,
      'click',
      this.onCreateTriggerClick,
    )
  }

  async onTriggerClick (event) {
    const target = event.target.closest(this.els?.trigger?.selector)
    if (!target) return
    if (this.locked) return

    this.locked = true

    const listId = target.dataset.listId

    target.setAttribute('aria-busy', 'true')

    if (target.getAttribute('data-added') === 'true') {
      const itemId = target.getAttribute('data-item-id')
      await this.removeFromWishlist(listId, itemId)
    } else {
      await this.addToWishlist(listId)
    }

    target.setAttribute('aria-busy', 'false')
  }

  async onCreateFormSubmit (event) {
    event.preventDefault()

    this.locked = true

    event.target.setAttribute('aria-busy', 'true')

    const formData = new FormData(event.target)
    const data = await window.BAO.wishlist.createList(formData, this.token)

    await this.addToWishlist(data.unique_id)
  }

  onCreateTriggerClick (event) {
    if (
      !event.target.closest(this.els['create-trigger-text'].selector) &&
      !event.target.closest(this.els['create-trigger-icon'].selector)
    ) {
      return
    }
    this.els['create-trigger-text'].element.setAttribute('aria-hidden', 'true')
    this.els['create-form'].element.setAttribute('aria-hidden', 'false')
  }

  async addToWishlist (listId) {
    const data = await window.BAO.wishlist.addToList(
      this.variantId,
      listId,
      this.token,
    )

    this.activator.listId = data.list_unique_id
    this.activator.itemId = data.unique_id
    this.activator.markActive()
    this.locked = false

    this.close()

    await window.BAO.wishlist.rerenderModal()

    this.activator = null
    window.BAO.wishlist.activator = null
  }

  async removeFromWishlist (listId, itemId) {
    await window.BAO.wishlist.removeItem(listId, itemId, this.token)
    await window.BAO.wishlist.rerenderModal()

    let productInAnyList = false
    const listItems = document.querySelectorAll(
      '.wsh-AddModal_Items script[data-list-json]',
    )
    listItems.forEach(script => {
      const listData = JSON.parse(script.textContent)
      const productInList = listData.products.some(
        product => product.productId === this.productId,
      )

      if (productInList) {
        productInAnyList = true
      }
    })

    // Fire the event if the product is not in any list
    if (!productInAnyList) {
      const event = new CustomEvent('wishlist-item-removed', {
        detail: {
          productId: this.productId,
        },
      })

      document.dispatchEvent(event)
    }

    this.locked = false

    this.close()
  }

  onCloseClick (event) {
    const target = event.target.closest(this.els?.close?.selector)
    if (!target) return

    this.close()
  }

  open () {
    if (!document.body.classList.contains('util-SelectVariant')) {
      document.body.classList.add('util-SiteOverflowed')
    }

    this.checkIfProductInList()
    this.setAttribute('aria-hidden', 'false')
  }

  close () {
    this.setAttribute('aria-hidden', 'true')
    this.els['create-trigger'].element.setAttribute('aria-hidden', 'false')
    this.els['create-form'].element.setAttribute('aria-hidden', 'true')

    this.resetLabelView()
    document.body.classList.remove('util-SiteOverflowed')
  }

  checkIfProductInList () {
    this.els.trigger?.elements.forEach(element => {
      const jsonScript = element.parentElement.querySelector(
        'script[type="application/json"]',
      )
      if (!jsonScript) return

      const listData = JSON.parse(jsonScript.textContent)
      const productInList = listData.products.some(
        product => product.productId === this.productId,
      )

      if (productInList) {
        this.showRemoveLabelView(element)
        const product = listData.products.find(
          product => product.productId === this.productId,
        )
        element.setAttribute('data-added', 'true')
        element.setAttribute('data-item-id', product.id)
        this.productsInList++
      } else {
        this.showAddedLabelView(element)
      }
    })
  }

  showAddedLabelView (trigger) {
    const addLabel = trigger.querySelector(
      '[data-wishlist-modal-el="trigger-label"][data-view="add"]',
    )
    const removeLabel = trigger.querySelector(
      '[data-wishlist-modal-el="trigger-label"][data-view="remove"]',
    )

    addLabel.hidden = false
    removeLabel.hidden = true
  }

  showRemoveLabelView (trigger) {
    const addLabel = trigger.querySelector(
      '[data-wishlist-modal-el="trigger-label"][data-view="add"]',
    )
    const removeLabel = trigger.querySelector(
      '[data-wishlist-modal-el="trigger-label"][data-view="remove"]',
    )

    addLabel.hidden = true
    removeLabel.hidden = false
  }

  resetLabelView () {
    this.els.trigger.elements.forEach(trigger => {
      const addLabel = trigger.querySelector(
        '[data-wishlist-modal-el="trigger-label"][data-view="add"]',
      )
      const removeLabel = trigger.querySelector(
        '[data-wishlist-modal-el="trigger-label"][data-view="remove"]',
      )

      addLabel.hidden = false
      removeLabel.hidden = true

      trigger.setAttribute('data-added', 'false')
    })
  }

  get productId () {
    return this.dataset.productId
  }

  get variantId () {
    return this.dataset.variantId
  }

  get token () {
    return window.BAO.wishlist.token
  }
}

customElements.define('wishlist-modal', WishlistModal)
